import { PropsWithChildren, useRef } from 'react'
import type {
  RawNonFilterParams,
  RawSearchFilters,
} from '@cinch-nx/data-search'
import {
  SearchStoreType,
  initialiseSearchStore,
} from './initialise-search-store'
import { SearchStoreContext } from './use-search-store'

export const SearchStoreProvider = ({
  children,
  params,
  isInsideStoryblok,
  allCinchStores,
  pathSegmentsFromUrl,
  isPriceUrlSegmentEnabled = false,
}: PropsWithChildren<{
  params: RawSearchFilters & RawNonFilterParams
  isInsideStoryblok: boolean
  allCinchStores: string[]
  pathSegmentsFromUrl: Partial<RawSearchFilters>
  isPriceUrlSegmentEnabled?: boolean
}>) => {
  const storeRef = useRef<SearchStoreType>()

  const shouldUseDataDrivenSortOrderAsDefault = true

  if (!storeRef.current) {
    storeRef.current = initialiseSearchStore({
      params,
      isInsideStoryblok,
      allCinchStores,
      pathSegmentsFromUrl,
      shouldUseDataDrivenSortOrderAsDefault,
      isPriceUrlSegmentEnabled,
    })
  }
  return (
    <SearchStoreContext.Provider value={storeRef.current}>
      {children}
    </SearchStoreContext.Provider>
  )
}
